export default __webpack_public_path__ + "static/media/img36.38164283.jpg";